module.exports = __webpack_public_path__ + "img/interlude_btn.ffa8ff2a.png";